import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectMutation, QueryClient } from '@tanstack/angular-query-experimental';
import { TaxService, CreateTaxRequest, UpdateTaxRequest } from '../../../../../../../../api';
import { QueryKey } from '../../../../../../../constants/query-key';

@Injectable()
export class TaxCommandService {
  private readonly taxService = inject(TaxService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateTaxRequest) =>
      lastValueFrom(this.taxService.createTax(request)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TAXES] });
    },
  }));

  updateMutation = injectMutation(() => ({
    mutationFn: (request: { id: number; body: UpdateTaxRequest }) =>
      lastValueFrom(this.taxService.updateTax(request.id, request.body)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TAXES] });
    },
  }));

  deleteMutation = injectMutation(() => ({
    mutationFn: (id: number) => lastValueFrom(this.taxService.deleteTax(id)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.TAXES] });
    },
  }));
}
